// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import LayerStyles from 'catena/er2_styles/layers'
import AOISelect from './aoi_select'
import ArcGISlayerProperties from './arcgisrest_layer_properties'
import type { AOIstate } from './aoi_select'

const styles = {
    blockStyle: {
        marginTop: '10px',
    },
    legend: {
    },
    legendHeader: {
        fontWeight: 'bold',
    },
    legendIndented: {
        marginLeft: '15px',
    },
    middle: {
        verticalAlign: 'middle',
    },
}

type PropsType = {
    classes: any,
    er2Map: any,
    label: string,
    layers: [{ id: number, visible: boolean }],
    loadingTileCounts: 0,
    name: string,
    onChangeProps: Function,
    onDelete: Function,
    onDownload: Function,
    opacity: number,
    service_name: String,
    theme: LayerStyles,
    url: string,
    visible: boolean,
}

type StateType = {
    displayDownloader: boolean,
    displayProps: boolean,
    downloadFeature: any,
}

class ArcgisrestLayer extends React.Component<PropsType, StateType> {
    state = {
        displayDownloader: false,
        displayProps: false,
        downloadFeature: null,
    }

    render() {
        const changeVisibility = (e) => {
            this.props.onChangeProps({ visible: e.target.checked })
            e.stopPropagation()
        }
        const expansionPanelClick = (event, expanded) => {
            this.setState({ expanded })
        }
        const showProps = (e) => {
            this.setState({ displayProps: !this.state.displayProps })
        }
        const onDelete = (e) => {
            this.props.onDelete(e)
            e.stopPropagation()
        }
        const onDownload = (e) => {
            this.setState({ displayDownloader: !this.state.displayDownloader })
            e.stopPropagation()
        }
        const stopPropagation = e => e.stopPropagation()

        const getLegend = () => (
            <div>
                {this.props.layers && this.props.layers.filter(l => l.visible && l.legend && l.legend.length).map((l) => {
                    let outerBlock
                    if (l.legend.length > 1) {
                        outerBlock = (
                            <span className={this.props.classes.legendHeader}>{l.name}</span>
                        )
                    }
                    return (
                        <div key={l.name} className={this.props.classes.blockStyle}>
                            {outerBlock}
                            {l.legend.map((ll, i) => {
                                const label = ll.label || l.name
                                return (
                                    <div
                                        key={`${ll.name}-${i}`}
                                        className={outerBlock ? this.props.classes.legendIndented : this.props.classes.legend}
                                    >
                                        <img
                                            alt={label}
                                            className={this.props.classes.middle}
                                            src={`data:${ll.contentType};base64,${ll.imageData}`}
                                        />
                                        <span>{label}</span>
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        )

        let layerprops = null
        if (this.state.displayProps) {
            const updateLayerProperties = (layerProps) => {
                this.props.onChangeProps(layerProps)
            }
            const { top, left } = this.ref.getBoundingClientRect()
            const root = document.getElementById('root')
            layerprops = ReactDOM.createPortal((
                <ArcGISlayerProperties
                    layerProps={this.props}
                    onChangeProps={updateLayerProperties}
                    onClose={() => this.setState({ displayProps: false })}
                    pos={{ top, right: root.getBoundingClientRect().right - left }}
                    theme={this.props.theme}
                />
            ), root)
        }

        let downloadOptions = null
        if (this.state.displayDownloader) {
            const handleClose = () => this.setState({ displayDownloader: false })
            downloadOptions = (
                <React.Fragment>
                    <AOISelect
                        classes={this.props.theme}
                        er2Map={this.props.er2Map}
                        onSelect={(aoiState: AOIstate) => {
                            this.setState({ downloadFeature: aoiState.aoiFeature })
                        }}
                        theme={this.props.theme}
                    />
                    {this.state.downloadFeature && [
                        (<Button
                            classes={{
                                root: this.props.theme.buttonSubmit,
                            }}
                            onClick={handleClose}
                        >
                            <span>Cancel</span>
                        </Button>),
                        (<Button
                            classes={{
                                root: this.props.theme.buttonSubmit,
                            }}
                            onClick={() => this.props.onDownload(this.state.downloadFeature)}
                        >
                            <span>Download</span>
                        </Button>),
                    ]}
                </React.Fragment>
            )
        }

        const waitIcon = (
            <img
                alt="loading service info"
                style={{ marginLeft: '4px' }}
                src={'/static/er2_map/img/loading.gif'}
            />
        )

        return (
            <div ref={(el) => {
                this.ref = el
            }}>
                <div
                    className={this.props.theme.layerPropsDiv}
                >
                    {layerprops}
                </div>
                <ExpansionPanel
                    classes={{
                        expanded: this.props.theme.panelExpanded,
                    }}
                    className={this.props.theme.panel}
                    onChange={expansionPanelClick}
                    style={{ backgroundColor: this.state.displayProps ? 'rgba(227, 234, 237)' : 'white' }}
                >
                    <ExpansionPanelSummary
                        classes={{
                            content: `${this.props.theme.panelSummary} ${this.state.expanded ? this.props.theme.panelClicked : ''}`,
                            expandIcon: this.props.theme.expandButton,
                        }}
                        className={this.props.theme.panelSummary}
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Checkbox
                            classes={{
                                root: this.props.theme.panelSwitch,
                            }}
                            checked={this.props.visible ? 'checked' : false}
                            onChange={changeVisibility}
                            onClick={stopPropagation}
                            color="secondary"
                        />
                        <Typography
                            className={this.props.theme.layerLabel}
                            style={{ fontWeight: this.props.visible ? 'bold' : 'normal' }}
                        >
                            {this.props.label}
                            {this.props.loadingTileCounts > 0 && waitIcon}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                        className={this.props.theme.panelDetails}
                    >
                        <div className={this.props.theme.table}>
                            <div className={this.props.theme.row}>
                                <IconButton
                                    onClick={showProps}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-window-restore'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={onDownload}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-download'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={onDelete}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-trash'} role="button" />
                                </IconButton>
                            </div>
                            {downloadOptions}
                            <Divider />
                        </div>
                        <div className={this.props.theme.table}>
                            <div className={this.props.theme.row}>
                                <div
                                    role="button"
                                    tabIndex={-1}
                                >
                                    {getLegend()}
                                </div>
                            </div>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        )
    }
}

export default withStyles(styles)(ArcgisrestLayer)
